import { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { useContactUsHandler } from '../../../../hooks';

export const useOpenChatFromHomeScreen = () => {
  const params = useLocalSearchParams<HomeScreenParams>();
  const router = useRouter();
  const { handleContactUs } = useContactUsHandler('home');

  return useCallback(() => {
    if (!params?.chat) return;

    router.setParams({ chat: 'false' });
    void handleContactUs();
  }, [params?.chat, router, handleContactUs]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type HomeScreenParams = {
  chat?: string;
};
